import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import performanceMetaUtility from '@sparta.global.utilities/performance-meta-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import { barker, applyNow, rating, termsAndConditions, getProgramRulesLink } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row campaign-properties-section\">\r\n</div>\r\n\r\n<div id=\"product-engagement-default\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":6,"column":47},"end":{"line":6,"column":61}}}))
    + "\"></div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"card-content column small-12 medium-10 medium-push-1 large-5 large-push-2\">\r\n  <div class=\"hide-for-large-up\">\r\n    <div class=\"card-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":6},"end":{"line":7,"column":13}}})) != null ? stack1 : "")
    + "\r\n      <img src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"contentRoot") : stack1), depth0))
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image") : stack1)) != null ? lookupProperty(stack1,"path") : stack1), depth0))
    + "\" alt=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image") : stack1)) != null ? lookupProperty(stack1,"alt") : stack1), depth0)) != null ? stack1 : "")
    + "\" class=\"card-image small-centered\" />\r\n    </div>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1)) != null ? lookupProperty(stack1,"toggle") : stack1),"===","YES",{"name":"compare","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":18,"column":16}}})) != null ? stack1 : "")
    + "  </div>\r\n\r\n  <h2 data-font=\"cnx-light\" class=\"small-9 medium-12\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"headline") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n\r\n  <p class=\"small-12\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"productHeadline") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n\r\n  <div class=\"show-for-large-up\">\r\n    <div class=\"eng-rates-and-fees\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_ANNUALFEE_RATESANDFEESLINK") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":6},"end":{"line":29,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n\r\n    <div class=\"apply-now-flex-container\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowMediumUp") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),null,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"applyNow") : stack1)) != null ? lookupProperty(stack1,"performanceMeta") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"USA_ENABLE") : stack1),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":33,"column":6},"end":{"line":41,"column":50}}})) != null ? stack1 : "")
    + "\r\n\r\n      <!-- Program Rules Link -->\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"params"))) && lookupProperty(stack1,"hasProgramRulesLink")),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":6},"end":{"line":51,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n  </div>\r\n\r\n  <div class=\"hide-for-large-up\">\r\n    <div class=\"eng-rates-and-fees\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_ANNUALFEE_RATESANDFEESLINK") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":57,"column":6},"end":{"line":59,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n\r\n    "
    + ((stack1 = (lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowSmall") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),null,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"applyNow") : stack1)) != null ? lookupProperty(stack1,"performanceMeta") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"USA_ENABLE") : stack1),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":62,"column":4},"end":{"line":70,"column":48}}})) != null ? stack1 : "")
    + "\r\n\r\n\r\n    <!-- Program Rules Link -->\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"params"))) && lookupProperty(stack1,"hasProgramRulesLink")),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":74,"column":4},"end":{"line":80,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>\r\n<div class=\"column small-6 small-offset-3 medium-3 medium-offset-0 large-3 large-push-2 show-for-large-up card-column\">\r\n  <div class=\"card-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":85,"column":4},"end":{"line":87,"column":11}}})) != null ? stack1 : "")
    + "\r\n    <img src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"contentRoot") : stack1), depth0))
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image") : stack1)) != null ? lookupProperty(stack1,"path") : stack1), depth0))
    + "\" alt=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image") : stack1)) != null ? lookupProperty(stack1,"alt") : stack1), depth0)) != null ? stack1 : "")
    + "\" class=\"card-image small-centered\" />\r\n  </div>\r\n\r\n  <!-- Product Offer Terms below card art-->\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"params"))) && lookupProperty(stack1,"hasOfferTermsBelowHeadline")),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":93,"column":2},"end":{"line":100,"column":9}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1)) != null ? lookupProperty(stack1,"toggle") : stack1),"===","YES",{"name":"compare","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":102,"column":2},"end":{"line":109,"column":14}}})) != null ? stack1 : "")
    + "</div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + ((stack1 = (lookupProperty(helpers,"barker")||(depth0 && lookupProperty(depth0,"barker"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BARKER_POSITION") : stack1),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BARKER_COLOR") : stack1),{"name":"barker","hash":{},"data":data,"loc":{"start":{"line":6,"column":6},"end":{"line":6,"column":135}}})) != null ? stack1 : "")
    + "\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <a id=\"ratings-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_VALUE") : stack1), depth0))
    + "\" class=\"rating-link\" target=\"_blank\" rel=\"noopener noreferrer\">\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"rating")||(depth0 && lookupProperty(depth0,"rating"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1),{"name":"rating","hash":{},"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":13,"column":34}}}))
    + "\r\n        <div class=\"summary\">\r\n          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_TEXT_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </div>\r\n      </a>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_ANNUALFEE_RATESANDFEESLINK") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_ENABLE") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":8},"end":{"line":50,"column":20}}})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"program-rules\">\r\n            "
    + container.escapeExpression((lookupProperty(helpers,"getProgramRulesLink")||(depth0 && lookupProperty(depth0,"getProgramRulesLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"programRulesPopup") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_LABEL") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_LINK") : stack1),{"name":"getProgramRulesLink","hash":{},"data":data,"loc":{"start":{"line":47,"column":12},"end":{"line":48,"column":51}}}))
    + "\r\n          </div>\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_ENABLE") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":75,"column":6},"end":{"line":79,"column":18}}})) != null ? stack1 : "");
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"program-rules\">\r\n          "
    + container.escapeExpression((lookupProperty(helpers,"getProgramRulesLink")||(depth0 && lookupProperty(depth0,"getProgramRulesLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"programRulesPopup") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_LABEL") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_LINK") : stack1),{"name":"getProgramRulesLink","hash":{},"data":data,"loc":{"start":{"line":77,"column":10},"end":{"line":77,"column":142}}}))
    + "\r\n        </div>\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    "
    + ((stack1 = (lookupProperty(helpers,"barker")||(depth0 && lookupProperty(depth0,"barker"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BARKER_POSITION") : stack1),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BARKER_COLOR") : stack1),{"name":"barker","hash":{},"data":data,"loc":{"start":{"line":86,"column":4},"end":{"line":86,"column":133}}})) != null ? stack1 : "")
    + "\r\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"OFFER_TERMS_ENABLE") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":94,"column":4},"end":{"line":99,"column":16}}})) != null ? stack1 : "");
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"offer-terms offer-terms_under-card\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"termsAndConditions")||(depth0 && lookupProperty(depth0,"termsAndConditions"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"termsAndConditionOffer") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),true,((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"OFFER_TERMS_LABEL") : stack1),{"name":"termsAndConditions","hash":{},"data":data,"loc":{"start":{"line":96,"column":6},"end":{"line":97,"column":45}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <a id=\"ratings-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_VALUE") : stack1), depth0))
    + "\" class=\"rating-link\" target=\"_blank\">\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"rating")||(depth0 && lookupProperty(depth0,"rating"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1),{"name":"rating","hash":{},"data":data,"loc":{"start":{"line":104,"column":6},"end":{"line":104,"column":32}}}))
    + "\r\n      <div class=\"summary\">\r\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_TEXT_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </a>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":111,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/product-engagement-cc-module",
  "version": "5.0.2",
  "id": "productEngagementCcModule",
  "containerID": "creditCardsProductEngagementCcModule",
  "moduleName": "credit-cards-product-engagement-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "product-engagement-cc-module",
  "data": {
    "init": "productEngagementCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "requesttype",
    "values": ["C", "BCC"],
    "default": "C",
    "description": "Consumer or Small Business Request Type"
  }, {
    "name": "hasOfferTermsBelowHeadline",
    "type": "Boolean",
    "default": false,
    "description": "Show Offer Terms (if available via PCM) below the product headline"
  }, {
    "name": "hasOfferTermsBelowCard",
    "type": "Boolean",
    "default": false,
    "description": "Show Offer Terms (if available via PCM) below the product card"
  }, {
    "name": "hasProgramRulesLink",
    "type": "Boolean",
    "default": false,
    "description": "Show Program Rules link (if available via PCM)"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        compare,
        json,
        barker,
        applyNow,
        rating,
        termsAndConditions,
        getProgramRulesLink,
        layerContent
      },
      "partials": {
        "product-engagement-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "product-engagement-partial": renderTemplate
  },
  "helpers": {
    compare,
    json,
    barker,
    applyNow,
    rating,
    termsAndConditions,
    getProgramRulesLink,
    layerContent
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.global.utilities/performance-meta-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-templates-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0"
  },
  "stores": []
};

/* eslint-disable no-param-reassign */

/* global sparta spaParams */

/**
 * product-engagement-cc-module
 * module_js_id: productEngagementCcModuleJS
 *
 * Copyright (c) 2017-12-4
 */

/**
 * @export
 * @class productEngagementCcModuleJS
 * @extends {Module}
 */
class productEngagementCcModuleJS extends Module {
  /**
   * Constructs an instance of productEngagementCcModuleJS
   * @param {Object} options - options to construct the class
   * @param {Object} context - Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.content = JSON.parse(target.querySelector('#product-engagement-default').dataset.jcr);
    this.templatePartial = _moduleConfig.partials['product-engagement-partial'];
  }

  /**
   * Initializes the instance
   * @returns {void}
   */
  init() {
    let campaignProperties;
    this.Events.sub('campaignProperties-spartaStore', data => {
      campaignProperties = data.data.data;
      const campaign = this.Store.getData('campaign');
      campaign.ID = creditCardUtility.buildCampaignString(campaign);
      campaign.rating = {
        toggle: campaignProperties.PRODUCT_REVIEW_RATING_ENABLE,
        value: campaignProperties.PRODUCT_REVIEW_RATING,
        URL: campaignProperties.PRODUCT_REVIEW_RATING_VALUE
      };
      const linkContent = creditCardUtility.generateLinkContent(this.content, {
        ID: campaign.ID,
        ...campaignProperties
      });
      const {
        target
      } = this.settings;
      const renderedTemplate = this.templatePartial({
        campaignProperties,
        campaign,
        content: linkContent,
        site: spaParams.siteParams,
        params: this.params,
        sparta
      });
      target.querySelector('.campaign-properties-section').innerHTML = renderedTemplate;
      this.Events.pub(creditCardUtility.EVENTS.productDetailsRendered, {
        module: this.settings.moduleInfo.name
      });

      // TODO: Remove after May 2019 release if feature flag is not enabled.
      // In potential edge cases, the welcome.go page needs to be prefetched to reset cookies.
      // This is a feature flag in case this edge case comes up during release.
      if (spaParams.siteParams.shouldPrefetchApplicationWelcomePage) {
        const metaTags = {
          link: [{
            rel: 'prefetch',
            href: `${spaParams.siteParams.secureHost}/applynow/welcome.go`
          }]
        };
        performanceMetaUtility.addMetaFromObject(metaTags);
      }
      performanceMetaUtility.addMetaFromClasses();
      this.fixRatesFeesLinks();
      this.populatePcmLinks(campaignProperties, campaign, linkContent, spaParams.siteParams, this.params, sparta);
      creditCardUtility.delegateEvent('click', '.spa-boa-tnc-window', this.handlePopupLink.bind(this), false, target);
      creditCardUtility.delegateEvent('click', '.spa-boa-program-rules-window', this.handlePopupLink.bind(this), false, target);
    });
  }

  /**
   * Fixes the rates and fees link that comes back from PCM.
   * @returns {void}
   */
  fixRatesFeesLinks() {
    const ratesContainers = [...this.settings.target.querySelectorAll('.eng-rates-and-fees')];
    ratesContainers.forEach(container => {
      const ratesLink = container.querySelector('a');
      if (ratesLink) {
        ratesLink.removeAttribute('onclick');
        ratesLink.setAttribute('href', '#interest-rates-and-fees');
      }
    });
  }

  /**
   * handlePopupLink
   *
   * @param {Event} e - click event
   * @returns {void}
   */
  handlePopupLink(e) {
    e.preventDefault();
    const {
      href,
      id
    } = e.target;
    spartaUILayersUtility.displayPopup(href, id, 'left=50,top=50,width=1100,height=750,scrollbars,status=1,resizable=1');
  }

  /**
   * @description Any offer terms links sent from PCM need to be updated
   * with the same href and class generated by the termsAndConditions helper.
   * @param {Object} campaignProperties campaign properties
   * @param {Object} campaign campaign
   * @param {Object} content content
   * @param {Object} site site
   * @param {Object} params params
   * @param {Object} sparta sparta
   * @returns {void}
   */
  populatePcmLinks(campaignProperties, campaign, content, site, params, sparta) {
    // Check for any offer terms links from PCM
    const pcmOfferTermsLinks = this.settings.target.querySelectorAll("[href='#creditCardTnCAnchor']");
    if (pcmOfferTermsLinks && pcmOfferTermsLinks.length > 0) {
      // Create Offer Terms TnC pop-up link string.
      const anchorString = termsAndConditions(content.LINKS.termsAndConditionOffer, campaign.ID, site, sparta, true, 'See Offer Terms' // Temporary string that will not be used ( we just need the href )
      );

      // Parse string for URL and programmatically obtain the href.
      const tempDivEl = document.createElement('div');
      tempDivEl.innerHTML = anchorString;
      const parsedAnchorTag = new URL(tempDivEl.firstChild);

      // Populate any links sent from PCM with the href and associated class
      pcmOfferTermsLinks.forEach(pcmLink => {
        pcmLink.href = parsedAnchorTag.href;
        pcmLink.classList.add('spa-boa-tnc-window');
      });
    }
  }
}
registerModuleClass({
  moduleClass: productEngagementCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { productEngagementCcModuleJS as default, moduleConfig };
